import { render, staticRenderFns } from "./WechatData.vue?vue&type=template&id=e7795988&scoped=true"
import script from "./WechatData.vue?vue&type=script&lang=js"
export * from "./WechatData.vue?vue&type=script&lang=js"
import style0 from "./WechatData.vue?vue&type=style&index=0&id=e7795988&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7795988",
  null
  
)

export default component.exports